module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.permissionsByDeviceDialog) ? _c('PermissionsByDevice', {
    attrs: {
      "userData": _vm.userData,
      "permissionsByDeviceDialog": _vm.permissionsByDeviceDialog
    },
    on: {
      "update:permissionsByDeviceDialog": function($event) {
        _vm.permissionsByDeviceDialog = $event
      },
      "update:permissions-by-device-dialog": function($event) {
        _vm.permissionsByDeviceDialog = $event
      }
    }
  }) : _c('v-row', {
    staticClass: "general-permissions custom-scroll-bar"
  }, [_c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbarTimeout,
      "top": "",
      "color": _vm.snackbarColor,
      "rounded": "",
      "centered": ""
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbarText) + "\n  ")]), _vm._v(" "), _c('Dialog', {
    attrs: {
      "dialog": _vm.permissionChangeDialog,
      "cardText": _vm.dialogCardText,
      "mainBtnText": _vm.dialogMainText,
      "secondaryBtnText": _vm.dialogSecondaryText
    },
    on: {
      "update:dialog": function($event) {
        _vm.permissionChangeDialog = $event
      },
      "mainBtnCallback": _vm.permissionChangeDialogMain,
      "secondaryBtnCallback": _vm.permissionChangeDialogSecondary
    }
  }), _vm._v(" "), _c('Dialog', {
    attrs: {
      "dialog": _vm.confirmPermissionChangeDialog,
      "cardText": _vm.dialogCardText,
      "mainBtnText": _vm.dialogMainText,
      "secondaryBtnText": _vm.dialogSecondaryText
    },
    on: {
      "update:dialog": function($event) {
        _vm.confirmPermissionChangeDialog = $event
      },
      "mainBtnCallback": _vm.confirmPermissionChangeDialogMain,
      "secondaryBtnCallback": _vm.confirmPermissionChangeDialogSecondary
    }
  }), _vm._v(" "), _c('v-col', {
    staticClass: "profile-pic-col",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-img', {
    staticClass: "profile-pic",
    attrs: {
      "id": "profile-pic",
      "height": "124",
      "width": "124",
      "src": _vm.profilePicSrc
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "9",
      "offset": "1"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "section-text text-left"
  }, [_vm._v(_vm._s(_vm.$t('GeneralPermissions.permissions')))])])], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, _vm._l((Object.keys(_vm.permissions)), function(perm) {
    return _c('v-col', {
      key: ("switch_" + perm)
    }, [_c('v-row', {
      staticClass: "permissions-elements flex-nowrap"
    }, [_c('v-switch', {
      attrs: {
        "inset": "",
        "color": "#00D166",
        "disabled": _vm.userData.permissionsCustomized
      },
      on: {
        "click": function($event) {
          return _vm.permissionChanged(perm)
        }
      },
      model: {
        value: (_vm.permissions[perm]),
        callback: function($$v) {
          _vm.$set(_vm.permissions, perm, $$v)
        },
        expression: "permissions[perm]"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "mb-0 text-start switch-text"
    }, [_vm._v(_vm._s(_vm.$t(("UsersPermissions." + perm))))])], 1)], 1)
  }), 1), _vm._v(" "), _c('v-row', {
    staticClass: "pt-5",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "text-left",
    attrs: {
      "cols": "12"
    }
  }, [_c('a', {
    staticClass: "clickable-text",
    on: {
      "click": _vm.viewPermissionsByDevice
    }
  }, [_vm._v(_vm._s(_vm.$t('GeneralPermissions.viewPermissionsByDevice')))])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pt-10",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "section-text text-left"
  }, [_vm._v(_vm._s(_vm.$t('GeneralPermissions.channels')))])])], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-row', {
    staticClass: "permissions-elements flex-nowrap"
  }, [_c('v-switch', {
    attrs: {
      "inset": "",
      "color": "#00D166"
    },
    on: {
      "click": function($event) {
        return _vm.changeChannel('push')
      }
    },
    model: {
      value: (_vm.pushChannel),
      callback: function($$v) {
        _vm.pushChannel = $$v
      },
      expression: "pushChannel"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mb-0 text-start switch-text"
  }, [_vm._v(_vm._s(_vm.$t('GeneralPermissions.push')))])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-row', {
    staticClass: "permissions-elements flex-nowrap"
  }, [_c('v-switch', {
    attrs: {
      "inset": "",
      "color": "#00D166"
    },
    on: {
      "click": function($event) {
        return _vm.changeChannel('whatsapp')
      }
    },
    model: {
      value: (_vm.whatsappChannel),
      callback: function($$v) {
        _vm.whatsappChannel = $$v
      },
      expression: "whatsappChannel"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mb-0 text-start switch-text"
  }, [_vm._v(_vm._s(_vm.$t('GeneralPermissions.whatsapp')))])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-row', {
    staticClass: "permissions-elements flex-nowrap"
  }, [_c('v-switch', {
    attrs: {
      "inset": "",
      "color": "#00D166"
    },
    on: {
      "click": function($event) {
        return _vm.changeChannel('sms')
      }
    },
    model: {
      value: (_vm.smsChannel),
      callback: function($$v) {
        _vm.smsChannel = $$v
      },
      expression: "smsChannel"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mb-0 text-start switch-text"
  }, [_vm._v(_vm._s(_vm.$t('GeneralPermissions.sms')))])], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pt-3",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2",
      "offset": "4"
    }
  }, [_c('v-btn', {
    staticClass: "text-none text-h6 font-weight-light",
    attrs: {
      "block": "",
      "color": "#0098E1",
      "large": "",
      "dark": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('GeneralPermissions.save')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ed3d8b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Additions/AddUser/GeneralPermissions.vue
// module id = 1723
// module chunks = 0